import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import DeleteModal from "components/Common/DeleteModal"
import { toast } from 'react-toastify';
import { salesDeveloperPrefix } from 'configs/routePrefix';
import StatusModal from "../StatusModal"
import { useSelector } from "react-redux"

const CardItem = ({ history, item, setShouldGetData }) => {
    const [modalStatus, setModalStatus] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const [status, setStatus] = useState(item?.status)

    return (
        <>
            <tr  >
                <td className="font-size-14">{item.id}</td>
                <td className="font-size-14">{item?.client?.user_name}</td>
                <td className="font-size-14">{item.sales_rep.name}</td>
                <td className="font-size-14">{item.created_at}</td>
                <td className="font-size-14">
                    {item?.unit?.unit_type ?.name ?.en ? item?.unit?.unit_type ?.name ?.en : item?.resale?.resale_type?.name?.en}
                </td>
                <td className="font-size-14">{item?.compound?.name?.en ? item?.compound?.name?.en : '-'}</td>
                <td className="font-size-14">
                    {item.price ? toCurrency(item.price) : toCurrency(item?.resale?.payment_plan?.total_price)}
                </td>
                <td className="font-size-14 text-left">
                    <Badge className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(status) }}>{status}</Badge>
                </td>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => history.push(`${salesDeveloperPrefix}/deals/view-deal/${item.id}`)}>View</DropdownItem>
                            {isExist("manage_deals_status") && <DropdownItem onClick={() => setModalStatus(true)} style={{ color: "#212529" }} >Change Status</DropdownItem>}
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            {modalStatus &&<StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item.id}
                setShouldGetData={setShouldGetData}
            />}
        </>

    );
}
const getBackGround = (status) => {
    return status === "Contacted" ? "#db1fdb"
    : status === "Uncontacted" ? "#74788d"
        : status === "Lost" ? "#bf060b"
            : status === "Won" ? "#34e38f"
                : status === "Open" ? "#50a5f1" :
                status === "Unreachable" ? "#556ee6" : "#f1874c"

}
const toCurrency = (number) => {
    const numberInt = parseInt(number)
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(numberInt);
}

export default CardItem;